import React from 'react';
import { useNavigate } from "react-router-dom";
import { useEffect, useState, useContext } from "react";
import { LanguageContext } from "../../../context/language/LanguageContext";
import { offerwallapi } from "../../../config/axiosconfig";
import { TenantContext } from "../../../context/tenant/TenantContext";
import { isMobile } from 'react-device-detect';

const TwitterShareButton = ({ imageUrl, campaignId, reward, chances, congratsImage, tnxId }) => {
    const navigate = useNavigate();
    const { language } = useContext(LanguageContext);
    const [caption, setCaption] = useState('');
    const [url, setUrl] = useState('');
    const { tenant } = useContext(TenantContext);

    useEffect(() => {
        setCaption(`${language?.static_labels.sharing_content_1} ${reward} ${language?.static_labels.yen} ${language?.static_labels.sharing_content_2} ${language?.static_labels.sharing_content_3} ${language?.static_labels.sharing_content_4} ${language?.static_labels.sharing_link} ${language?.static_labels.sharing_tags} ${language?.static_labels.sharing_hash_tags}`);
        setUrl(language?.static_labels.sharing_link);
    }, [reward, language])

    const addSocialShareDetails = async () => {
        let info = {
            tnxId: tnxId,
            tenantid: tenant.tenantid,
            platform: "X"
        }
        const res = await offerwallapi.post("/api/gamification/add-social-share-details", info);
        if (res.status === 200) { }
    }

    const handleWebShare = async () => {
        if (navigator.share) {
            try {
                await navigator.share({
                    title: caption,
                    text: caption,
                    url: url,
                    files: [new File([await fetch(`/api/common/fetch-image?url=${imageUrl}`).then(res => res.blob())], 'image.png', { type: 'image/png' })],
                });
            } catch (error) {
                console.error('Sharing failed:', error);
            }
        } else {
            alert('Web Share API not supported in your browser.');
        }
    }

    return (
        <button style={{ border: 'none', backgroundColor: 'white' }} onClick={isMobile ? () => {
            addSocialShareDetails();
            handleWebShare();
        } : () => {
            navigate(`/visa-japan/gamification/sharing`, {
                state: {
                    reward: reward,
                    chances: chances,
                    campaignId: campaignId,
                    congratsImage: congratsImage,
                    type: 'twitter',
                    imageUrl: imageUrl,
                    tnxId: tnxId
                }
            });
        } }>
            <img src={require('../../../images/twitter-icon.png')} alt="Instagram" />
        </button>
    );
}

export default TwitterShareButton;